import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // colorSchemes: { light: true, dark: true },
  cssVariables: {
    colorSchemeSelector: 'class',
  },
  palette: {
    primary: {
      main: '#446493',
    },
    secondary: {
      main: '#F4A261', 
    },
    background: {
      default: '#FFFFFF', 
      
    },
    text: {
      primary: '#141d34', 
    },
    
  },
  typography: {
    fontFamily: ['"Roboto"', 'sans-serif'].join(','),
    fontSize: 14, 
    h1: {
        fontFamily: '"Lora", serif',
        fontSize: '3rem',  
        fontWeight: 700,  
      },
      h2: {
        fontFamily: '"Lora", serif',
        fontSize: '2.5rem', 
        fontWeight: 700,
      },
      h3: {
        fontFamily: '"Lora", serif',
        fontSize: '2rem',  
        fontWeight: 700,
      },
      h4: {
        fontFamily: '"Lora", serif',
        fontSize: '1.75rem',  
        fontWeight: 700,
      },
      h5: {
        fontFamily: '"Lora", serif',
        fontSize: '1.5rem', 
        fontWeight: 700,
      },
      h6: {
        fontFamily: '"Lora", serif',
        fontSize: '1.25rem',  
        fontWeight: 700,
      },

      body1: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '1rem', 
        fontWeight: 400,  
      },
      body2: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '0.875rem',  
        fontWeight: 400,
      },

      button: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '0.875rem', 
        fontWeight: 500,  
      },
  
      caption: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '0.75rem', 
        fontWeight: 400,
      },
      overline: {
        fontFamily: '"Roboto", sans-serif',
        fontSize: '0.75rem',  
        fontWeight: 400,
      },
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Lora", serif', 
          fontSize: '1rem', 
          fontWeight: 400,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          color: 'white',
          '& nav.MuiBox-root': {
          background: 'linear-gradient(160deg, #446493 0%, #2F3F61 100%)',

          },
          '& nav.MuiBox-root svg': {
               color: 'white',
               transition: 'color 0.3s ease',
          },
          '& .MuiPaper-root': {
            background: 'linear-gradient(160deg, #446493 0%, #2F3F61 100%)',

          },
          '& .MuiPaper-root a': {
                    color: "white"
          },
          '& .MuiListItem-root:hover .MuiSvgIcon-root': {
            color: '#F4A261',
          },
          '& .MuiListItem-root:hover': {
            backgroundColor: 'linear-gradient(90deg, rgba(244,162,97,0.2), rgba(244,162,97,0.3))',
          },
          '& .Mui-selected': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            '& .MuiSvgIcon-root': {
              color: '#F4A261',
            },
          },
        },
      },
    },
  },
});

export { theme };
